import Joi from "joi-browser";

export function createIndexColumns(controls) {
  
  const columns = [];
  controls
    .filter((x) => x.section == 3)
    .forEach((col) => {
      const key = col.controlName;
      if (key.toLowerCase() === "id") {
        columns.push({ title: key, field: key, hidden: true });
      } else if (col && !col.isHidden) {
        const cellStyle = { paddingLeft: 4, paddingRight: 0 };
        const headerStyle = { paddingLeft: 4, paddingRight: 0 };
        if (col.width) {
          cellStyle.width = col.width;
          cellStyle.minWidth = col.width;
          headerStyle.width = col.width;
          headerStyle.minWidth = col.width;
        }
        columns.push({
          title: col.caption || col.fieldName,
          field: col.fieldName,
          cellStyle,
          headerStyle,
          type:(["string","boolean","numeric","date","datetime","time","currency"].indexOf(col.dataType) >-1)// TODO >> NEED TEST WITH MANY TYPES
            ?col.dataType:"string",
        });
      }
    });

  return columns;
}

export function renderColumn(fieldName, control, colProps) {
  const colStyle = { paddingLeft: 5, paddingRight: 5 };
  control = control || {};
  if (!control.isHidden) {
    if (control.width) {
      colStyle.width = colStyle.minWidth = colStyle.maxWidth = control.width;
    }
  }

  return {
    field: fieldName,
    title: control.caption || fieldName,
    hidden: !!control.isHidden || false,
    cellStyle: { ...colStyle },
    headerStyle: { ...colStyle },
    ...colProps,
    //editable: "always",
  };
}
export function renderColumnDataGrid(fieldName, control, colProps) {
  control = control || {};
  return {
    field: fieldName,
    headerName: control.caption || fieldName,
    hide: !!control.isHidden || false,
    width: control.width,
    headerClassName: "super-app-theme--header",
    ...colProps,
    //editable: "always",
  };
}
export function createFormSchema(formControls) {
  if (!formControls) return {};
  const newSchema = {};
  for (const key in formControls) {
    if (Object.hasOwnProperty.call(formControls, key)) {
      const control = formControls[key];
      if (control.isHidden) {
        continue;
      }
      if (!control.fieldName) {
        continue;
      }
      if (!newSchema[control.controlName]) newSchema[control.controlName] = {};

      newSchema[control.controlName] = Joi.label(control.caption);

      if (control.required) {
        if (control.dataType.toLowerCase() === "number") {
          if (control.MinValue && control.MaxValue) {
            newSchema[control.controlName] = Joi.number()
              .empty("")
              .required()
              .min(parseFloat(control.MinValue))
              .max(parseFloat(control.MaxValue));
          } else if (control.MinValue) {
            newSchema[control.controlName] = Joi.number()
              .empty("")
              .required()
              .min(parseFloat(control.MinValue));
          } else if (control.MaxValue) {
            newSchema[control.controlName] = Joi.number()
              .empty("")
              .required()
              .max(parseFloat(control.MaxValue));
          } else
            newSchema[control.controlName] = Joi.number().empty("").required();
        } else if (
          control.dataType.toLowerCase() === "date" ||
          control.dataType.toLowerCase() === "smalldatetime"
        ) {
          newSchema[control.controlName] = Joi.date().empty(null).required();
          // .min(control.MinValue)
          // .max(control.MaxValue);
        } else if (control.dataType.toLowerCase() === "string") {
          newSchema[control.controlName] = Joi.string().required();
        } else {
          newSchema[control.controlName] = Joi.any().empty("").required();
        }
      } else if (control.dataType.toLowerCase() === "number") {
        if (control.MinValue && control.MaxValue) {
          newSchema[control.controlName] = Joi.number()
            .allow(null)
            .min(parseFloat(control.MinValue))
            .max(parseFloat(control.MaxValue));
        } else if (control.MinValue) {
          newSchema[control.controlName] = Joi.number()
            .allow(null)
            .min(parseFloat(control.MinValue));
        } else if (control.MaxValue) {
          newSchema[control.controlName] = Joi.number()
            .allow(null)
            .max(parseFloat(control.MaxValue));
        } else
          newSchema[control.controlName] = Joi.number().empty("").allow(null);
      } else if (
        control.dataType.toLowerCase() === "date" ||
        control.dataType.toLowerCase() === "smalldatetime"
      ) {
        newSchema[control.controlName] = Joi.date().allow(null);
        // .min(control.MinValue)
        // .max(control.MaxValue);
      }
    }
  }
  return newSchema;
}

export function validateProperty(name, value, propSchema) {
  const obj = { [name]: value };
  if (!propSchema) return null;
  const schema = { [name]: propSchema };
  const { error } = Joi.validate(obj, schema);
  return error ? error.details[0].message : null;
}

export function validateForm(data, formSchema) {
  const options = {
    abortEarly: false,
    stripUnknown: true, // To Ignor fields that not exist in validation schema
  };
  const { error } = Joi.validate(data, formSchema, options);
  if (!error) return null;

  const errors = {};
  for (const item of error.details) errors[item.path[0]] = item.message;
  return errors;
}

export function mapFormControlsToObject(controls) {
  if (!controls || (controls && controls.length === 0)) return {};

  const formControls = {};
  controls.map((control) => {
    formControls[control.controlName] = { ...control };
  });
  return formControls;
}

export function validate(formSchema, errors, fieldName, value) {
  const err = { ...errors };
  const errorMessage = validateProperty(
    fieldName,
    value,
    formSchema[fieldName]
  );
  if (errorMessage) err[fieldName] = errorMessage;
  else delete err[fieldName];

  return err;
}

export function getSubFormContrlsObj(formControls, subFormcontrolNamesArray) {
  const subFormContrlsObj = {};
  for (const key in formControls) {
    if (formControls.hasOwnProperty(key)) {
      if (subFormcontrolNamesArray.indexOf(key) > -1) {
        subFormContrlsObj[key] = formControls[key];
      }
    }
  }
  return subFormContrlsObj;
}

export function getNextSerial(tableDataArr) {
  if (!tableDataArr.length) return 1;

  const maxSerial = Math.max(...tableDataArr.map((o) => o.serial));
  if (isNaN(maxSerial)) {
    return tableDataArr.length + 1;
  } else {
    return maxSerial + 1;
  }
}

export function saveSubFormRow(tableData, rowData) {
  const newTableData = [...tableData];

  const saveMode = rowData.id === "add" ? 1 : 2;

  if (saveMode === 1) {
    rowData.id = Date.now();
    newTableData.push(rowData);
  } else {
    const rowIndex = newTableData.findIndex((x) => x.id == rowData.id);
    newTableData[rowIndex] = { ...rowData };
  }

  return newTableData;
}

export function deleteSubFormRow(tableData, rowData) {
  const newTableData = [...tableData];

  const rowIndex = newTableData.findIndex((x) => x.id === rowData.id);
  newTableData.splice(rowIndex, 1);
  for (let i = rowIndex; i < newTableData.length; i++) {
    newTableData[i].serial = i + 1;
  }

  return newTableData;
}

export function parseAndRound(value, decimals) {
  if (isNaN(value)) return 0;
  if (isNaN(parseFloat(value))) return 0;

  //let val = parseFloat(isNaN(value) ? 0 : value);
  let val = parseFloat(value);
  if (!decimals) return val;

  let x = "1";
  for (let index = 0; index < decimals; index++) {
    x = x.concat("0");
  }
  val = Math.round((val + Number.EPSILON) * parseInt(x, 10)) / parseInt(x, 10);
  return val;
}

export function isEmptyObject(obj) {
  return !obj || Object.keys(obj).length === 0;
}